import { route } from '@/ziggy-shim';
import { api } from './LaravelClient';

export default {
  async store(projectId: Id, packageId: Id, data: ApiRequests['api.v1.scope-gap-categories.store']) {
    return await api(route('api.v1.scope-gap-categories.store', { project: projectId, package: packageId }), 'post', {
      data,
    });
  },

  async update(id: Id, data: ApiRequests['api.v1.scope-gap-categories.update']) {
    return await api(route('api.v1.scope-gap-categories.update', id), 'patch', {
      data,
    });
  },

  async destroy(id: Id) {
    return await api(route('api.v1.scope-gap-categories.destroy', id), 'delete');
  },

  async sort(id: Id, data: ApiRequests['api.v1.scope-gap-categories.sort']) {
    return await api(route('api.v1.scope-gap-categories.sort', id), 'patch', {
      data,
    });
  },
};
